export enum Category {
    AppetizersAndSides = 1,
    FoodsAndDishes = 2,
    Protein = 3,
    Flavors = 4,
    GlobalFoods = 6,
    Desserts = 7,
    SnackFoods = 8,
    AlcoholicBeverages = 9,
    NonAlcoholicBeverages = 10,
    HealthyAndDescriptors = 11,
    Brands = 12,
    EggsAndDairy = 35,
    FruitsAndVeggies = 36,
    RiceBeansNutsAndSeeds = 37,
    Breads = 38,
    SweetenerOilsVinegarsAndSpecialty = 39,
}

export const FILTERS_CATEGORIES_GROUPS = [
    [
        Category.AppetizersAndSides,
        Category.Breads,
        Category.EggsAndDairy,
        Category.AlcoholicBeverages,
    ],
    [
        Category.FoodsAndDishes,
        Category.Protein,
        Category.FruitsAndVeggies,
        Category.NonAlcoholicBeverages,
    ],
    [
        Category.Flavors,
        Category.RiceBeansNutsAndSeeds,
        Category.HealthyAndDescriptors,
        Category.Brands,
    ],
    [
        Category.SnackFoods,
        Category.Desserts,
        Category.SweetenerOilsVinegarsAndSpecialty,
        Category.GlobalFoods,
    ],
]